export enum RequestTabEnum {
  AllRequests = 'all-requests',
  LeaveRequests = 'leave-requests',
  ShiftRequests = 'shift-requests',
  OpenShifts = 'open-shifts',
  Documents = 'documents',
}
